export const MODERATION_EVENT_TYPE = 'DeviceInfraction' as const
export const AUTO_TYPE_LABEL = 'Auto' as const
export const NOT_AVAILABLE = 'Not Available' as const
export const UNKNOWN_STATE = 'Unknown'
export const UNKNOWN_TYPE = 'Type unknown'
export const UNKNOWN_NAME = 'Name unknown'
export const UNKNOWN_ID = 'ID unknown'

export const CAMERA_OVERVIEW_URL = (locationId: string) => `/locations/${locationId}/monitoring-moderation/camera-overview`
export const CAMERA_OVERVIEW_URL_WITH_CAMERA_ID = (locationId: string, cameraId: string) =>
  `/locations/${locationId}/monitoring-moderation/camera-overview/${cameraId}`

export enum IgnoreReasonLabel {
  DuplicateClearance = 'Duplicate Clearance',
  CameraNotEnrolled = 'Camera Not Enrolled',
  LocationNotSubscribed = 'Location Not Subscribed',
  AmbiguousCamera = 'Ambiguous Camera'
}

export enum AutomatedInfractionTypeLabel {
  ImproperDevicePlacement = 'Camera Inside',
  InappropriateBehaviorWitnessed = 'Undressed Person Inside'
}

export enum BadgeStatus {
  Active = 'Active',
  Warned = 'Warned',
  Unenrolled = 'Unenrolled',
  PreviouslyUnenrolled = 'Previously Unenrolled',
  Notified = 'Notified',
  UnenrollFailed = 'Unenroll • Failed',
  WarnFailed = 'Warn • Failed',
  WarnedFirst = 'Warned • 1st',
  WarnedFinal = 'Warned • Final'
}

export enum ActionType {
  Communication = 'CustomerCommunication',
  UnenrollCamera = 'UnenrollCamera',
  ReenrollCamera = 'ReenrollCamera',
  Escalation = 'CustomerEscalation'
}

export enum ModerationEventStatus {
  Draft = 'Draft',
  Active = 'Active',
  Completed = 'Completed',
  Failed = 'Failed'
}

export enum ActionStatus {
  Pending = 'Pending',
  Active = 'Active',
  Completed = 'Completed'
}

export enum ActionResults {
  Success = 'Success',
  Failure = 'Failure'
}
